import styles from "./SecurityCard.module.less";
import SOC from "../../assets/SOC-logo.png";
import Image from "next/image";

export const SecurityCard = () => {
  return (
    <div className={styles.SecurityCard}>
      <div className={styles.Content}>
        We adhere to
        <ul>
          <li>GDPR</li>
          <li>CCPA</li>
          <li>FCRA</li>
          <li>GLBA</li>
        </ul>
      </div>
      <div>
        <Image src={SOC.src} width={255} height={255} alt="SOC logo" />
      </div>
    </div>
  );
};
